import React, { useState } from "react";
import Button from "../../Button";
import { Headphones, PlayArrowFill } from "@material-symbols-svg/react";
import { X } from "lucide-react";
import VideoPlayerModal from "../../modals/common/VideoPlayerModal";
import { EXTERNAL_URLS } from "src/constants/common";

const CGM_DEMO_VIDEO_URL = EXTERNAL_URLS.CGM_VIDEO_HOW_IT_WORKS;

type CGMJourneyHeaderProps = {
  onClose: () => void;
  onChatClick: () => void;
};

const CGMJourneyHeader: React.FC<CGMJourneyHeaderProps> = ({
  onClose,
  onChatClick,
}) => {
  const [showDemoVideo, setShowDemoVideo] = useState(false);

  return (
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-2">
        <Button
          type="button"
          variant="contained"
          color="primary"
          rounded="full"
          size="sm"
          onClick={() => setShowDemoVideo(true)}
        >
          <PlayArrowFill />
          <span>Watch CGM Demo</span>
        </Button>
        <VideoPlayerModal
          show={showDemoVideo}
          title="Watch CGM Demo"
          handleClose={() => setShowDemoVideo(false)}
          videoUrl={CGM_DEMO_VIDEO_URL}
          type="youtube"
        />

        <button
          className="p-1 rounded-full bg-white border border-[var(--app-primary)] text-[var(--app-primary)]"
          onClick={onChatClick}
        >
          <Headphones className="w-4 h-4 font-semibold" />
        </button>
      </div>
      <button
        type="button"
        onClick={onClose}
        className="w-9 h-9 rounded-full bg-white/90 border border-gray-200 shadow-sm flex items-center justify-center"
        aria-label="Close"
      >
        <X className="w-5 h-5 text-gray-600" />
      </button>
    </div>
  );
};

export default CGMJourneyHeader;
